/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AssignmentRestrictionNotSetPassword } from './AssignmentRestrictionNotSetPassword';
import { AssignmentRestrictionSetPassword } from './AssignmentRestrictionSetPassword';
const AssignmentRestrictionParser = 
/* #__PURE__ */ parsers.object([
    [
        'password',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['set', AssignmentRestrictionSetPassword],
            ['not-set', AssignmentRestrictionNotSetPassword],
        ]),
    ],
]);
export class AssignmentRestriction extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentRestrictionParser.decode(input).map(res => new AssignmentRestriction(res));
    }
    static unsafeDecode(input) {
        return AssignmentRestriction.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentRestrictionParser.encode(data);
    }
    static schema() {
        return AssignmentRestrictionParser.schema();
    }
}
